import { useEffect, useState } from 'react'
import { Lock } from 'lucide-react'
import api from '@/lib/api'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Dialog } from '@/components/ui/dialog'
import { useToast } from '@/components/ui/toast'

const SENHA_MIN = 6

/** Troca a senha do próprio usuário logado (dropdown da topbar). */
export default function AlterarSenhaModal({ open, onClose }) {
  const toast = useToast()
  const [senha, setSenha] = useState('')
  const [confirmacao, setConfirmacao] = useState('')
  const [erro, setErro] = useState('')
  const [salvando, setSalvando] = useState(false)

  useEffect(() => {
    if (open) {
      setSenha(''); setConfirmacao(''); setErro('')
    }
  }, [open])

  const curta = senha !== '' && senha.length < SENHA_MIN
  const divergem = confirmacao !== '' && senha !== confirmacao
  const podeSalvar = senha.length >= SENHA_MIN && senha === confirmacao

  async function salvar() {
    if (!podeSalvar) return
    setSalvando(true)
    setErro('')
    try {
      await api.put('/auth/senha', { senha, senhaConfirmacao: confirmacao })
      toast.success('Senha alterada com sucesso.')
      onClose()
    } catch (err) {
      setErro(err?.response?.data?.error || 'Não foi possível alterar a senha.')
    } finally {
      setSalvando(false)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Alterar senha"
      description="Defina a nova senha de acesso ao sistema."
      size="sm"
      footer={<>
        <Button variant="outline" onClick={onClose}>Cancelar</Button>
        <Button onClick={salvar} disabled={!podeSalvar || salvando}>
          {salvando ? 'Salvando...' : 'Alterar senha'}
        </Button>
      </>}
    >
      <div className="space-y-4">
        <div className="space-y-1.5">
          <Label className="flex items-center gap-1.5"><Lock className="h-3.5 w-3.5" /> Nova senha</Label>
          <Input
            type="password"
            autoFocus
            name="nova-senha"
            autoComplete="new-password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="••••••••"
          />
          {curta
            ? <p className="text-xs text-destructive">Mínimo de {SENHA_MIN} caracteres.</p>
            : <p className="text-xs text-muted-foreground">Mínimo de {SENHA_MIN} caracteres.</p>}
        </div>

        <div className="space-y-1.5">
          <Label>Confirmar nova senha</Label>
          <Input
            type="password"
            name="confirmar-senha"
            autoComplete="new-password"
            value={confirmacao}
            onChange={(e) => setConfirmacao(e.target.value)}
            placeholder="••••••••"
            onKeyDown={(e) => e.key === 'Enter' && salvar()}
          />
          {divergem && <p className="text-xs text-destructive">As senhas não conferem.</p>}
        </div>

        {erro && <p className="text-sm text-destructive">{erro}</p>}
      </div>
    </Dialog>
  )
}
